import React, {useEffect, useState} from 'react';
import {getGames, addGame, addAdmin, refreshCache, getAdmins, deleteAdmin} from './api';
import {useNavigate} from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';

const AdminDashboard = () => {
    const [packages, setPackages] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [newPackageName, setNewPackageName] = useState('');
    const [newAdmin, setNewAdmin] = useState({username: '', password: '', role: ''});
    const token = localStorage.getItem('token');
    const navigate = useNavigate();

    const decodedToken = jwtDecode(token);
    const isSuperAdmin = decodedToken.role === 'superadmin';

    const fetchGamesList = async () => {
        try {
            const data = await getGames(token);
            setPackages(data.packages || []);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchAdminsList = async () => {
        try {
            const data = await getAdmins(token);
            setAdmins(data.admins || []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchGamesList();
        fetchAdminsList();
    }, []);

    const handleAddGame = async () => {
        if (!newPackageName) return;
        try {
            await addGame(token, newPackageName);
            setNewPackageName('');
            fetchGamesList();
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddAdmin = async () => {
        if (!newAdmin.username || !newAdmin.password || !newAdmin.role) return;
        try {
            await addAdmin(token, newAdmin);
            setNewAdmin({username: '', password: '', role: ''});
            fetchAdminsList();
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteAdmin = async (username) => {
        if (window.confirm(`Are you sure you want to delete admin ${username}?`)) {
            try {
                await deleteAdmin(token, username);
                fetchAdminsList();
            } catch (err) {
                console.error(err);
            }
        }
    };

    // const handleRefreshCache = async () => {
    //     try {
    //         await refreshCache(token);
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    const logout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between mb-4">
                <h2>Games</h2>
                <button onClick={logout} className="btn btn-secondary">Logout</button>
            </div>

            <div className="mb-3 d-flex">
                <input
                    className="form-control"
                    placeholder="New Game Package Name"
                    value={newPackageName}
                    onChange={e => setNewPackageName(e.target.value)}
                />
                <button onClick={handleAddGame} className="btn btn-primary ms-2">Add</button>
            </div>

            {isSuperAdmin && (
                <>
                    <div className="mb-3 d-flex">
                        <input
                            className="form-control"
                            placeholder="New Admin Username"
                            value={newAdmin.username}
                            onChange={e => setNewAdmin({...newAdmin, username: e.target.value})}
                        />
                        <input
                            className="form-control"
                            placeholder="New Admin Password"
                            type="password"
                            value={newAdmin.password}
                            onChange={e => setNewAdmin({...newAdmin, password: e.target.value})}
                        />
                        <input
                            className="form-control"
                            placeholder="New Admin Role"
                            value={newAdmin.role}
                            onChange={e => setNewAdmin({...newAdmin, role: e.target.value})}
                        />
                        <button onClick={handleAddAdmin} className="btn btn-primary ms-2">Add Admin</button>
                    </div>
                </>
            )}

            {/*<button onClick={handleRefreshCache} className="btn btn-warning mb-3">Reload Cache</button>*/}

            {isSuperAdmin && (
                <>
                    <h2>Admins</h2>
                    <table className="table">
                        <thead>
                        <tr>
                            <th>Username</th>
                            <th>Role</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {admins.map(admin => (
                            <tr key={admin.username}>
                                <td>{admin.username}</td>
                                <td>{admin.role}</td>
                                <td>
                                    <button className="btn btn-sm btn-danger"
                                            onClick={() => handleDeleteAdmin(admin.username)}>Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </>
            )}

            <h2>Games</h2>
            <table className="table">
                <thead>
                <tr>
                    <th>Package Name</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {packages.map(pkg => (
                    <tr key={pkg}>
                        <td>{pkg}</td>
                        <td>
                            <button className="btn btn-sm btn-info"
                                    onClick={() => navigate(`/admin/packages/${pkg}`)}>View Markets
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminDashboard;